import { useChatbotList } from 'hooks/useChatbotList';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function LoadBot() {
  const { isFetching, isSuccess, data } = useChatbotList();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess && data?.length) {
      const id = data[0].id;

      navigate(`/${id}/conversations`);
    }
  }, [navigate, isSuccess, data]);

  if (!isFetching && isSuccess && (!data || !data?.length)) {
    return <h1>There are no Chatbots assigned to you. Contact Sofi for help :)</h1>;
  }

  return <h1>Loading...</h1>;
}
